import styled, { css, keyframes } from 'styled-components';
import LazyLoadOriginal from '../LazyLoad/LazyLoad';

const pulseAnimation = keyframes`
  0%, 100% {
    background-color: var(--hover);
  }
  45% {
    background-color: var(--border);
  }
`;

export const LazyLoad = styled(LazyLoadOriginal)`
  position: absolute;
  inset: 0;
`;

export const Video = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  opacity: ${({ hasLoaded }) => (hasLoaded ? 1 : 0)};
`;

export const Container = styled.div`
  height: 0;
  padding-bottom: ${({ aspectRatio = 1 }) => aspectRatio * 100}%;
  position: relative;
  ${({ hasLoaded }) =>
    hasLoaded
      ? 'animation: none'
      : css`
          animation: ${pulseAnimation} 3s ease-out infinite normal;
        `};
`;
